/**
 * Compare dotted numeric versions (e.g. "1.0", "2.1.3"). Non-numeric segments count as 0.
 */
export function compareVersionStrings(left: string, right: string): number {
  const leftParts = left.split(".").map((part) => parseInt(part, 10) || 0);
  const rightParts = right.split(".").map((part) => parseInt(part, 10) || 0);
  const length = Math.max(leftParts.length, rightParts.length);
  for (let index = 0; index < length; index += 1) {
    const leftValue = leftParts[index] ?? 0;
    const rightValue = rightParts[index] ?? 0;
    if (leftValue < rightValue) {
      return -1;
    }
    if (leftValue > rightValue) {
      return 1;
    }
  }
  return 0;
}
